export default __webpack_public_path__ + "static/media/location.d5ec2ecc.png";